import { Integration } from "@/types/general";
import { cn } from "@helpers/utils";
import ImportEntityHistoryBadge from "./ImportEntityHistoryBadge";
import { isPreviouslyImported } from "./importHistory";

interface ImportEntitySummaryCardProps {
    label: string;
    icon: JSX.Element;
    history?: Integration.Import.HistoryItem;
    className?: string;
}

export default function ImportEntitySummaryCard({
    label,
    icon,
    history,
    className,
}: ImportEntitySummaryCardProps) {
    const hasImportHistory = isPreviouslyImported(history);

    return (
        <div
            className={cn(
                "flex flex-row items-center justify-between gap-3 border-[1px] border-solid rounded-[8px] p-[16px] text-accent",
                hasImportHistory ? "border-[#F2B84B] bg-[#FFFDF7]" : "border-inputs-border-default",
                className
            )}
        >
            <div className="flex min-w-0 flex-wrap items-center gap-2">
                <span>{label}</span>
                <ImportEntityHistoryBadge history={history} />
            </div>
            <div className="shrink-0">{icon}</div>
        </div>
    );
}
